<div class="top-action">
  <ng-content select="wchfs-breadcrumbs"></ng-content>
  <div class="actions-wrap">
    <ng-content select=".actions"></ng-content>
  </div>
</div>
